<script setup lang="ts">
// Get global loader state with accessibility delay
const { isVisible, currentMessage } = useGlobalLoader()
</script>

<template>
  <!-- Global loader overlay using pure Tailwind classes -->
  <Transition
    enter-active-class="transition-opacity duration-300 ease-out"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition-opacity duration-200 ease-in"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="isVisible"
      class="fixed inset-0 z-[9999] flex items-center justify-center"
      style="background-color: rgba(0, 0, 0, 0.3); backdrop-filter: blur(2px)"
    >
      <div
        class="flex min-w-40 flex-col items-center gap-5 rounded-2xl bg-default/85 px-10 py-8 shadow-xl ring ring-default"
      >
        <AppLoader size="xl" variant="3d" />
        <div v-if="currentMessage" class="max-w-100 text-center font-medium text-default">
          {{ currentMessage }}
        </div>
      </div>
    </div>
  </Transition>
</template>
